import { RootState } from '@dealstack/frontend/app/redux/store';
import { createSelector } from '@reduxjs/toolkit';

const selectUser = (state: RootState) => state.user;

export const selectUserId: (state: RootState) => string | undefined = createSelector(
	selectUser,
	(user) => user.data?.id
);
